import { render } from "./otherRequests.vue?vue&type=template&id=71980c9e"
import script from "./otherRequests.vue?vue&type=script&lang=js"
export * from "./otherRequests.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__